import { createContext } from 'react';

import type { ProductContext } from './types';

export const productContext = createContext<ProductContext>(undefined as unknown as ProductContext);
